import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, invoiceFormData } from "./InvoiceFile";
import {
  dropdownData,
  formatDate,
  formatNumber,
  getRecords,
  saveRecords,
} from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import NumberInput from "../../custom/components/Number-Input/NumberInput";
import ModernPopup from "../../services/popup/Popup";
import * as XLSX from "xlsx";

const InvoiceCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
  } = createPageData();

  const fileInputRef = useRef(null);
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(invoiceFormData());
  const [projectSelect, setProjectSelect] = useState("");
  const [projectSelectOptions, setProjectSelectOptions] = useState([]);
  const [warehouseSelect, setWarehouseSelect] = useState("");
  const [warehouseSelectOptions, setWarehouseSelectOptions] = useState([]);
  const [orderSelect, setOrderSelect] = useState("");
  const [orderSelectOptions, setOrderSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedFilteredItems, setSelectedFilteredItems] = useState([]);
  const [filteredOptionsWithoutSelected, setFilteredOptionsWithoutSelected] =
    useState([]);
  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.invoice_order_items || []
  );
  const [expandedRows, setExpandedRows] = useState({});
  const [fetchedData, setFetchedData] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [items, setItems] = useState([]);
  const dropdownRef = useRef(null);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const inputRef = useRef(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData[0];
      const invoiceOrderItems = data?.invoice_order_items
        ?.filter((item) => item.is_active === true)
        ?.map((item) => ({
          id: item.id,
          order_item_id: item.order_item_id,
          item_id: item?.item_details?.item_id,
          item_code: item?.item_details?.item_code,
          description: item?.item_details?.item_desc,
          customer_desc: item?.customer_desc,
          // order_qty:parseFloat(item?.qty || 0) - parseFloat(item?.invoice_qty || 0),
          order_qty: item?.qty,
          invoice_qty: item?.invoice_qty,
          unit_rate: item?.unit_rate,
          gst_percentage: item?.gst_percentage,
          amount: item?.amount,
          inward_qty: null,
          is_active: item?.is_active,
          type: item?.item?.type,
          uom: item?.item_details?.uom,

          buy_item_details:
            item.item.type === 1
              ? item.buy_item_details?.map((buyItem) => ({
                  item_id: buyItem?.item_details?.item_id,
                  item_code: buyItem?.item_details?.item_code,
                  item_desc: buyItem?.item_details?.item_desc,
                  qty: buyItem?.qty,
                  uom: buyItem?.item_details?.uom,
                  qty_per_item: buyItem?.qty_per_item,
                }))
              : [],
        }));
      // Update the formData state
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          order_id: data?.order_id,
          warehouse_id: data?.warehouse_id,
          gst_no: data?.gst_no,
          invoice_no: data?.invoice_no,
          order_date: data?.order_date,
          address: data?.address,
          remark: data?.remark,
          is_active: data?.is_active,
          invoice_order_items: invoiceOrderItems,
        },
      }));
      setFilteredItems(invoiceOrderItems);
    }
  }, [fetchedData]);

  useEffect(() => {
    getWarehouseDropData();
    getProjectsDropData();
  }, []);

  const getEditData = async (Id) => {
    try {
      let payload = {
        modelName: "invoices",
        relations: [
          {
            module: "invoice_order_items",
            moduleAs: "invoice_order_items",
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
        ],
        whereCondition: {
          id: Id,
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData?.code == 1) {
        await getOrderDropData(
          responseData?.data[0]?.project_id,
          responseData?.data[0]?.order_id
        );

        await getWarehouseDropData(
          responseData?.data[0]?.project_id,
          responseData?.data[0]?.warehouse_id
        );
        setFetchedData(responseData?.data);

        const orderIdData = {
          id: responseData?.data[0].order_id,
          project_id: responseData?.data[0].project_id,
        };

        await setOrderEditData(
          orderIdData,
          responseData?.data[0].invoice_order_items
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getProjectsDropData = async (Id) => {
    try {
      const project_id = JSON.parse(localStorage.getItem("projectID"));
      getOrderDropData(project_id);
      setProjectSelect(project_id);
      let payload = {
        modelName: "projects",
        whereCondition: {
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/listProject");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "project_name"
        );
        setProjectSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getOrderDropData = async (Id, orderId) => {
    try {
      let whereCondition = {};
      if (!id) {
        whereCondition = {
          is_order_invoice_completed: false,
          project_id: Id,
          is_active: true,
        };
      } else {
        whereCondition = {
          is_order_invoice_completed: false,
          project_id: Id,
          is_active: true,
          id: orderId,
        };
      }
      let payload = {
        modelName: "orders",
        whereCondition,
      };

      const responseData = await getRecords(payload, "/notFullyInvoicedOrders");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "order_no"
        );
        if (orderId) {
          dropdownResponseData[0].options?.forEach((element) => {
            if (element?.value == orderId) {
              setOrderSelect(element);
            }
          });
        }
        setOrderSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getWarehouseDropData = async (Id, warehouseId) => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      let payload = {
        modelName: "warehouse_masters",
        whereCondition: {
          project_id: projectId,
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "warehouse_name"
        );
        if (warehouseId) {
          dropdownResponseData[0].options?.forEach((element) => {
            if (element?.value == warehouseId) {
              setWarehouseSelect(element);
            }
          });
        }
        setWarehouseSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const setOrderData = async (orderIdData) => {
    try {
      let payload = {
        modelName: "orders",
        whereCondition: {
          project_id: orderIdData?.project_id,
          id: orderIdData?.id,
        },
        relations: [
          {
            module: "order_payment_details",
            moduleAs: "orderPaymentDetails",
          },
          {
            module: "order_items",
            moduleAs: "orderItemDetails",
            isModuleWhereConditionRequired: true,
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
        ],
        // modifyResponse: true,
        // getActualInvoiceQtyForInvoiceFromOrder: true,
        moduleWhereCondition: {
          is_order_item_invoice_completed: false,
        },
      };
      let responseData = await getRecords(payload, "/listOrder");
      if (responseData?.data && responseData.data.length > 0) {
        const selectedData = responseData?.data[0];
        const invoiceOrderItems = selectedData?.orderItemDetails
          ?.filter((item) => item.is_active === true)
          ?.map((item) => ({
            order_item_id: item.id,
            item_id: item.item_id,
            item_code: item?.item?.item_code,
            description: item?.item?.description,
            customer_desc: item?.customer_desc,
            order_qty:
              parseFloat(item?.qty || 0) - parseFloat(item?.invoice_qty || 0),
            unit_rate: item?.unit_rate,
            gst_percentage: item?.gst_percentage,
            amount: item?.amount,
            inward_qty: null,
            is_active: false,
            type: item?.item?.type,
            uom: item.item.uom?.uom_name,

            buy_item_details:
              item.item.type === 1
                ? item.buy_item_details?.map((buyItem) => ({
                    item_id: buyItem?.item_id,
                    item_code: buyItem?.item_code,
                    item_desc: buyItem?.item_desc,
                    qty:
                      (parseFloat(item?.qty || 0) -
                        parseFloat(item?.invoice_qty || 0)) *
                      buyItem?.qty_per_item,

                    uom: buyItem?.uom,
                    qty_per_item: buyItem?.qty_per_item,
                  }))
                : [],
          }));
        // Update the formData state
        setFormData((prevState) => ({
          ...prevState,
          inputData: {
            ...prevState.inputData,
            order_id: orderIdData?.id,
            gst_no: selectedData?.gst_no,
            order_date: selectedData?.order_date,
            address: selectedData?.address,
            invoice_order_items: invoiceOrderItems,
          },
        }));
        setFilteredItems(invoiceOrderItems);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = TransactionalValidation(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleOrderSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      order_id: selectedValue,
    });
    setOrderSelect(options);

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      order_id: fieldError?.order_id || "",
    }));

    if (selectedValue) {
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          invoice_no: "",
          remark: "",
        },
      }));

      const selectedOrder = options.data.find(
        (item) => item.id === selectedValue
      );

      if (selectedOrder) {
        const orderIdData = {
          id: selectedOrder.id,
          project_id: selectedOrder.project_id,
        };
        setOrderData(orderIdData);
      } else {
        console.error(`No matching order found for id: ${selectedValue}`);
      }
    }
  };

  const handleWarehouseSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      warehouse_id: selectedValue,
    });

    setWarehouseSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      warehouse_id: fieldError?.warehouse_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        warehouse_id: selectedValue,
      },
    }));
  };

  const handleAccessChange = (e, index) => {
    const { name, checked } = e.target;

    setFormData((prev) => {
      const updatedDetails = prev.inputData.invoice_order_items.map((item, i) =>
        item.item_id === index ? { ...item, [name]: checked } : item
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          invoice_order_items: updatedDetails,
        },
      };
    });

    setFilteredItems((prev) =>
      prev.map((item, i) =>
        item.item_id === index ? { ...item, [name]: checked } : item
      )
    );

    if (!checked) {
      setFormErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        const fieldKey = `row_${index}_invoice_qty`;
        if (newErrors[fieldKey] === "Invoice qty is required") {
          delete newErrors[fieldKey];
        }
        return newErrors;
      });
    }
  };

  const totalQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.order_qty) || 0),
      0
    );

  const totalUnitRate =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.unit_rate) || 0),
      0
    );

  const totalInvoiceQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.invoice_qty) || 0),
      0
    );

  const totalAmountData =
    filteredItems &&
    filteredItems.reduce(
      (acc, item) => acc + (parseFloat(item?.amount) || 0),
      0
    );

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const submissionType = e?.nativeEvent?.submitter?.name;

      const validationErrors = TransactionalValidation(
        validationType,
        formData.inputData
      );

      if (Object.keys(validationErrors).length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      let updatedFormData = { ...formData };
      const hasActiveInwardItem =
        updatedFormData?.inputData?.invoice_order_items?.some(
          (item) => item?.is_active
        );

      if (!hasActiveInwardItem) {
        toast.error("At least one inward item must be active.");
        return;
      }
      const errors = {};

      updatedFormData?.inputData?.invoice_order_items?.forEach((row, index) => {
        const fieldKey = `row_${row.item_id}_invoice_qty`;
        if (
          row.invoice_qty !== null &&
          parseFloat(row.invoice_qty) > row?.order_qty
        ) {
          errors[fieldKey] =
            "Invoice qty should not be greater than order qty.";
        }

        if (row?.is_active) {
          if (!row.invoice_qty?.toString().trim() || row.invoice_qty == "") {
            errors[fieldKey] = "Invoice qty is required";
          }
        }
      });

      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }

      let transformedInputData = {
        warehouse_id: updatedFormData?.inputData?.warehouse_id || null,
        project_id: updatedFormData?.inputData?.project_id || null,
        order_id: updatedFormData?.inputData?.order_id || null,
        invoice_no: updatedFormData?.inputData?.invoice_no || null,
        remark: updatedFormData?.inputData?.remark || null,
        created_by: updatedFormData?.inputData?.created_by || 1,
        is_active: updatedFormData?.inputData?.is_active,
        is_submitted: submissionType === "save" ? false : true,
        invoice_order_items: updatedFormData?.inputData?.invoice_order_items
          ?.filter((item) => item.is_active)
          ?.map((item) => {
            const baseItem = {
              item_details: {
                item_id: item.item_id,
                item_code: item.item_code,
                item_desc: item.description,
                uom: item.uom,
              },
              forceSave: true,
              id: item?.id || undefined,
              order_item_id: item.order_item_id,
              item_id: item.item_id,
              item_code: item.item_code,
              description: item.description,
              customer_desc: item?.customer_desc,
              qty: item.order_qty,
              invoice_qty: item.invoice_qty,
              unit_rate: item.unit_rate,
              gst_percentage: item.gst_percentage,
              amount: item.amount,
              type: item.type,
              uom: item.uom,
            };

            if (item.type === 1) {
              return {
                ...baseItem,
                buy_item_details: item.buy_item_details?.map((detail) => ({
                  item_details: {
                    item_id: detail.item_id,
                    item_code: detail.item_code,
                    item_desc: detail.item_desc,
                    uom: detail.uom,
                  },
                  item_id: detail.item_id,
                  item_code: detail.item_code,
                  item_desc: detail.item_desc,
                  qty: detail.qty,
                  uom: detail.uom,
                  order_item_id: item.order_item_id,
                })),
              };
            }

            return baseItem;
          }),
      };

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const isCreating = !id;
      const updatedInputData = {
        ...transformedInputData,
        created_by: isCreating
          ? userDetails.id
          : updatedFormData.inputData.created_by,
        updated_by: userDetails.id,
        project_id: projectSelect,
      };
      const payload = {
        id: id,
        checkAfterSave: true,
        checkInvoiceCompleted: true,
        modelName: initialPayload?.modelName,
        relation: initialPayload?.relation,
        inputData: updatedInputData,
        actionType: "checkInvoiceCompleted",
      };

      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(`${headerName} saved successfully!`);
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.trim() === "") {
      setFilteredItems(formData?.inputData?.invoice_order_items || []);
    } else {
      const filtered =
        formData?.inputData?.invoice_order_items.filter((item) =>
          item?.item_code?.toLowerCase().includes(value.toLowerCase())
        ) || [];
      setFilteredItems(filtered);
    }
  };

  useEffect(() => {});

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleQTYChange = (value, rowIndex, key, orderQty, row, name) => {
    const fieldKey = `row_${rowIndex}_${name}`;

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (newErrors[fieldKey]) {
        delete newErrors[fieldKey];
      }
      if (value !== "" && !isNaN(value) && parseFloat(value) > orderQty) {
        newErrors[fieldKey] =
          "Invoice qty should not be greater than order qty.";
      }
      if (row.is_active && (value === "" || isNaN(value))) {
        newErrors[fieldKey] = "Invoice Qty is required";
      }
      return newErrors;
    });

    const numericValue = parseFloat(value) || 0;

    let totalWithGST = 0;
    if (row && row?.unit_rate && row?.gst_percentage) {
      const baseAmount = numericValue * row?.unit_rate;
      const gstAmount =
        (baseAmount * parseFloat(row?.gst_percentage || 0)) / 100;
      totalWithGST = baseAmount + gstAmount;
    }

    let updatedItems = formData.inputData.invoice_order_items.map(
      (item, index) => {
        if (item.item_id === rowIndex) {
          return {
            ...item,
            [key]: numericValue,
            amount: totalWithGST,
            buy_item_details:
              item?.buy_item_details?.map((buyItem) => ({
                ...buyItem,
                qty: numericValue * buyItem.qty_per_item || 0,
              })) || [],
          };
        } else {
          return {
            ...item,
            buy_item_details:
              item?.buy_item_details?.map((buyItem) => ({
                ...buyItem,
                qty: item.invoice_qty * buyItem.qty_per_item || 0,
              })) || [],
          };
        }
      }
    );

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        invoice_order_items: updatedItems,
      },
    }));

    if (inputValue.trim() === "") {
      setFilteredItems(updatedItems);
    } else {
      const filtered =
        updatedItems.filter((item) =>
          item?.item_code?.toLowerCase().includes(inputValue.toLowerCase())
        ) || [];
      setFilteredItems(filtered);
    }
  };
  const handleOrderQTYChange = (value, rowIndex, key, row, name) => {
    const fieldKey = `row_${rowIndex}_${name}`;

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (newErrors[fieldKey]) {
        delete newErrors[fieldKey];
      }

      if (row.is_active && (value === "" || isNaN(value))) {
        newErrors[fieldKey] = "Order Qty is required";
      }
      return newErrors;
    });
    const numericValue = parseFloat(value) || 0;

    const updatedItems = [...filteredItems];

    updatedItems[rowIndex] = {
      ...updatedItems[rowIndex],
      [key]: numericValue,
    };

    setFilteredItems(updatedItems);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        invoice_order_items: updatedItems,
      },
    }));
  };

  const closePopup = () => {
    setPopupData((prev) => ({ ...prev, isOpen: false }));
  };

  const handleImportItemDetail = async (e) => {
    if (!orderSelect) {
      toast.error("Please select SO No. first");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    try {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = null;

      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        toast.error("Please select a valid Excel file.");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      const reader = new FileReader();
      reader.readAsBinaryString(file);

      reader.onload = async (event) => {
        try {
          const binaryStr = event.target.result;
          const workbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(sheet);

          if (!data || data?.length === 0) {
            setPopupData({
              isOpen: true,
              message: `The uploaded file is empty or not formatted correctly.`,
              isError: true,
            });
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            return;
          }

          setLoadingData(true);
          const filteredFilterItem = filteredItems
            ?.map((filter) => {
              const matchingItem = data.find(
                (item) => item.item_code.trim() == filter.item_code.trim()
              );

              if (matchingItem) {
                if (filter.type == 1) {
                  const buy_item_details = filter?.buy_item_details || [];
                  if (buy_item_details.length > 0) {
                    for (const item of buy_item_details) {
                      const qty_per_item = item.qty_per_item;
                      item.qty = matchingItem.invoice_qty * qty_per_item;
                    }
                  }
                }
              }
              return matchingItem
                ? {
                    ...filter,
                    invoice_qty: matchingItem.invoice_qty,
                    amount: parseFloat(
                      (
                        matchingItem.invoice_qty *
                        filter.unit_rate *
                        (1 + filter.gst_percentage / 100)
                      ).toFixed(3)
                    ),
                    is_active: true,
                  }
                : null;
            })
            ?.filter(Boolean);

          const matchedData = data?.flatMap((excelItem) =>
            filteredFilterItem.filter(
              (item) => item.item_code.trim() == excelItem.item_code.trim()
            )
          );

          const matchedItemCodes = matchedData?.map((item) => item?.item_code);

          const uploadedItemCodes = data?.map(
            (dataItem) => dataItem?.item_code
          );

          const unmatchedItemCodes = uploadedItemCodes?.filter(
            (code) =>
              !matchedItemCodes.map(String).includes(String(code.trim()))
          );

          setFormErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            if (newErrors.invoice_order_items) {
              matchedItemCodes.forEach((code) => {
                if (newErrors.invoice_order_items[code]?.invoice_qty) {
                  delete newErrors.invoice_order_items[code].invoice_qty;
                }

                if (
                  Object.keys(newErrors.invoice_order_items[code] || {})
                    .length === 0
                ) {
                  delete newErrors.invoice_order_items[code];
                }
              });

              if (
                Object.keys(newErrors.invoice_order_items || {}).length === 0
              ) {
                delete newErrors.invoice_order_items;
              }
            }

            return newErrors;
          });

          setFilteredItems(filteredFilterItem);
          setFormData((prevState) => ({
            ...prevState,
            inputData: {
              ...prevState.inputData,
              invoice_order_items: filteredFilterItem,
            },
          }));
          setPopupData({
            isOpen: true,
            message: "File imported successfully!",
            isError: false,
            unmatchedItems: unmatchedItemCodes,
            matchedItems: matchedData,
          });
          setLoadingData(false);
        } catch (error) {
          setLoadingData(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          console.error("Processing error:", error);
          setPopupData({
            isOpen: true,
            message: "Error processing the file. Please check the format.",
            isError: true,
          });
        }
      };
    } catch (error) {
      setLoadingData(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      console.error("error", error);
    }
  };
  const setOrderEditData = async (orderIdData, itemID) => {
    try {
      let payload = {
        modelName: "orders",
        whereCondition: {
          project_id: orderIdData?.project_id,
          id: orderIdData?.id,
        },
        relations: [
          {
            module: "order_payment_details",
            moduleAs: "orderPaymentDetails",
          },
          {
            module: "order_items",
            moduleAs: "orderItemDetails",
            isModuleWhereConditionRequired: true,
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
        ],
        // modifyResponse: true,
        // getActualInvoiceQtyForInvoiceFromOrder: true,
        moduleWhereCondition: {
          is_order_item_invoice_completed: false,
        },
      };
      let responseData = await getRecords(payload, "/listOrder");
      if (responseData?.data && responseData.data.length > 0) {
        // setFilteredItems(invoiceOrderItems);
        if (id) {
          const dropdownResponseData = await dropdownData(
            responseData.data[0]?.orderItemDetails.map((item) => item.item),
            "item_code"
          );

          const matchingItems =
            itemID?.map((item) =>
              !item.is_active
                ? undefined
                : dropdownResponseData[0]?.options?.find(
                    (element) => item.item_id === element?.value
                  )
            ) || [];
          setFilteredOptions(() =>
            dropdownResponseData[0]?.options.filter(
              (option) =>
                !matchingItems.some(
                  (selected) => selected?.label === option?.label
                )
            )
          );
          setSelectedFilteredItems((prev) => [...prev, ...matchingItems]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const filteredOptionsWithoutSelectedItems = filteredOptions?.filter(
      (item) =>
        !(selectedFilteredItems ?? []).some(
          (selected) =>
            selected?.item_code?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase() ||
            selected?.label?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase()
        )
    );
    setFilteredOptionsWithoutSelected(filteredOptionsWithoutSelectedItems);
  }, [filteredOptions, selectedFilteredItems]);
  const getItemMasterByIdData = async (Id, index, orderIdData) => {
    try {
      let payload = {
        modelName: "orders",
        whereCondition: {
          project_id: orderIdData?.project_id,
          id: orderIdData?.id,
        },
        relations: [
          {
            module: "order_payment_details",
            moduleAs: "orderPaymentDetails",
          },
          {
            module: "order_items",
            moduleAs: "orderItemDetails",
            isModuleWhereConditionRequired: true,
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
        ],
        // modifyResponse: true,
        // getActualInvoiceQtyForInvoiceFromOrder: true,
        moduleWhereCondition: {
          is_order_item_invoice_completed: false,
        },
      };

      const responseData = await getRecords(payload, "/listOrder");

      if (responseData.data && responseData.data.length > 0) {
        const matchedItems = responseData.data[0]?.orderItemDetails?.filter(
          (item) => item.item_id == Id
        );

        matchedItems.forEach((item) => {
          setFormData((prev) => {
            const updatedDetails = [...prev.inputData.invoice_order_items];

            updatedDetails[index] = {
              ...updatedDetails[index],
              order_item_id: item.id,
              item_id: item.item_id,
              item_code: item?.item?.item_code,
              description: item?.item?.description,
              customer_desc: item?.customer_desc,
              order_qty:
                parseFloat(item?.qty || 0) - parseFloat(item?.invoice_qty || 0),
              unit_rate: item?.unit_rate,
              gst_percentage: item?.gst_percentage,
              amount: item?.amount,
              inward_qty: null,
              is_active: false,
              type: item?.item?.type,
              uom: item.item.uom?.uom_name,
              buy_item_details:
                item.item.type === 1
                  ? item.buy_item_details?.map((buyItem) => ({
                      item_id: buyItem?.item_id,
                      item_code: buyItem?.item_code,
                      item_desc: buyItem?.item_desc,
                      qty:
                        (parseFloat(item?.qty || 0) -
                          parseFloat(item?.invoice_qty || 0)) *
                        buyItem?.qty_per_item,
                      uom: buyItem?.uom,
                      qty_per_item: buyItem?.qty_per_item,
                    }))
                  : [],
            };
            setFilteredItems(updatedDetails);

            return {
              ...prev,
              inputData: {
                ...prev.inputData,
                invoice_order_items: updatedDetails,
              },
            };
          });
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);

    if (value.trim() === "") {
      const filteredOptionsWithoutSelectedItems = filteredOptions?.filter(
        (item) =>
          !(selectedFilteredItems ?? []).some(
            (selected) =>
              selected?.item_code?.toString().trim().toLowerCase() ===
                item?.label?.toString().trim().toLowerCase() ||
              selected?.label?.toString().trim().toLowerCase() ===
                item?.label?.toString().trim().toLowerCase()
          )
      );
      setFilteredOptionsWithoutSelected(filteredOptionsWithoutSelectedItems);
    } else {
      const filteredOptionsWithoutSelectedItems =
        filteredOptionsWithoutSelected?.filter((option) =>
          option?.label
            ?.toString()
            .trim()
            .toLowerCase()
            .includes(value?.toString().trim().toLowerCase())
        );
      setFilteredOptionsWithoutSelected(filteredOptionsWithoutSelectedItems);
    }
  };
  const handleItemSelect = async (item) => {
    if (!item || !item.label) {
      console.error("Invalid item selected:", item);
      return;
    }

    setSearchInputValue(item.label);
    const data = item.label;
    setIsDropdownVisible(false);

    handleAddItem(item);
  };
  const handleAddItem = async (data) => {
    let emptyRowIndex = filteredItems.length || 0;
    const selectedOrder = orderSelect.data.find(
      (d) => d.id == orderSelect.value
    );

    const payload = {
      id: selectedOrder?.id,
      project_id: selectedOrder?.project_id,
    };

    await getItemMasterByIdData(data.value, emptyRowIndex, payload);

    setSelectedFilteredItems((prev) => {
      const updatedSelected = [...prev, data];

      const updatedFilteredOptions = filteredOptions?.filter(
        (item) =>
          !updatedSelected.some(
            (selected) =>
              selected?.item_code?.toString().trim().toLowerCase() ===
                item?.label?.toString().trim().toLowerCase() ||
              selected?.label?.toString().trim().toLowerCase() ===
                item?.label?.toString().trim().toLowerCase()
          )
      );
      setFilteredOptionsWithoutSelected(updatedFilteredOptions);

      return updatedSelected;
    });

    toast.success(`The item "${data.label}" added successfully`);

    setSearchInputValue("");
  };
  return (
    <CustomForm
      title={"CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      noSaveButton={true}
      id={id}
    >
      <ModernPopup
        isOpen={popupData.isOpen}
        onClose={closePopup}
        message={popupData.message}
        isError={popupData.isError}
        unmatchedItems={popupData?.unmatchedItems}
        matchedItems={popupData?.matchedItems}
      />

      {!id && (
        <Row>
          <Col className="d-flex justify-content-end text-center">
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Import Items
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              accept=".xlsx, .xls"
              onChange={(e) => handleImportItemDetail(e)}
            />
          </Col>
        </Row>
      )}
      <Row className="mt-2">
        {/* First Row */}
        <Col md="4" className="mt-3">
          <SelectInput
            label="SO No"
            value={orderSelect}
            options={orderSelectOptions}
            onSelect={(selected) => handleOrderSelect(selected)}
            placeholder="Select order no"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.order_id}
            // disabled={id ? true : false}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Invoice No"
            name="invoice_no"
            value={formData?.inputData?.invoice_no}
            onChange={onInputChange}
            placeholder="Invoice no"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.invoice_no}
          />
        </Col>

        <Col md="4" className="mt-3">
          <SelectInput
            label="Warehouse"
            value={warehouseSelect}
            options={warehouseSelectOptions}
            onSelect={(selected) => handleWarehouseSelect(selected)}
            placeholder="Select warehouse"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.warehouse_id}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Order date"
            value={formatDate(formData?.inputData?.order_date)}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="No Data Found"
            readOnly={true}
            disabled={true}
          />
        </Col>

        <Col md="4" className="mt-3">
          <TextAreaInput
            label="Address"
            value={formData?.inputData?.address}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="no data found"
            readOnly={true}
            disabled={true}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        {!id ? (
          <Col
            style={{
              marginBottom: "0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h6
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                backgroundColor: "#f8f9fa",
                padding: "10px 20px",
                borderRadius: "8px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "inline-block",
                margin: "0px",
              }}
            >
              Item Details
            </h6>

            <div>
              <div className="app-search d-flex d-lg-inline mt-0 w-25">
                <div className="position-relative">
                  <input
                    type="search"
                    className="form-control ps-5"
                    placeholder="Search by item code.."
                    value={inputValue}
                    onChange={handleInputChange}
                    style={{
                      width: "13rem",
                      padding: "8px 15px",
                      borderRadius: "8px",
                      borderColor: "#D2D2D2",
                      outline: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "none",
                      marginRight: "0.5rem",
                    }}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </div>
            </div>
          </Col>
        ) : (
          <Col className="responsive-flex">
            <div>
              <h6 className="h-6-heading">Item Details</h6>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div className="app-search d-flex d-lg-inline mt-0 w-25">
                  <div className="position-relative">
                    <input
                      ref={inputRef}
                      id="itemCode"
                      type="text"
                      value={searchInputValue}
                      onChange={handleSearchInputChange}
                      // onKeyDown={handleInputKeyDown}
                      placeholder="Add item code..."
                      className="form-control ps-5"
                      autoComplete="off"
                      onFocus={() => {
                        setIsDropdownVisible(true);
                      }}
                      style={{
                        width: "13rem",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        borderColor: "#D2D2D2",
                        outline: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "none",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </div>

                {isDropdownVisible && (
                  <div
                    ref={dropdownRef}
                    style={{
                      width: "13rem",
                      maxHeight: "150px",
                      overflowY: "auto",
                      border: "1px solid #D2D2D2",
                      borderRadius: "8px",
                      marginTop: "5px",
                      position: "absolute",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                      zIndex: "1000",
                    }}
                  >
                    {filteredOptionsWithoutSelected &&
                    filteredOptionsWithoutSelected.length > 0 ? (
                      filteredOptionsWithoutSelected?.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            handleItemSelect(item);
                          }}
                          style={{
                            padding: "8px 15px",
                            cursor: "pointer",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#f0f0f0")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "transparent")
                          }
                        >
                          {item.label}
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: "8px 15px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                          textAlign: "center",
                          color: "gray",
                        }}
                      >
                        No Data..
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>
        )}

        <div
          className="table mt-2"
          style={{
            // overflow: "auto",
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Description</th>
                <th style={{ whiteSpace: "nowrap" }}>Customer Description</th>
                <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                <th style={{ whiteSpace: "nowrap" }}>Order QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Invoice QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Unit Rate</th>
                <th style={{ whiteSpace: "nowrap" }}>GST %</th>
                <th style={{ whiteSpace: "nowrap" }}>Total Amount</th>
                <th style={{ whiteSpace: "nowrap" }} colSpan="4">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredItems && filteredItems?.length > 0 ? (
                filteredItems?.map((row, index) => {
                  return (
                    <React.Fragment key={index}>
                      {/* Main Item Row */}
                      <tr
                        style={{
                          borderBottom: "1px solid #cccccc",
                          verticalAlign: "middle",
                        }}
                      >
                        <td>{index + 1}</td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleRow(index);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px", // Spacing between text and icon
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              cursor: row?.type == 1 && "pointer",
                            }}
                            title={row?.item_code || "N/A"}
                          >
                            <span>{row?.item_code || "N/A"}</span>

                            {row?.type === 1 && (
                              <Link
                                className="text-primary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleRow(index);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <i
                                  className={`mdi mdi-chevron-${
                                    expandedRows[index] ? "up" : "down"
                                  } font-size-18`}
                                ></i>
                              </Link>
                            )}
                          </div>
                        </td>

                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={row?.description || "N/A"}
                          >
                            {row?.description || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={row?.customer_desc || "N/A"}
                          >
                            {row?.customer_desc || "N/A"}
                          </div>
                        </td>

                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "100px",
                          }}
                        >
                          {row?.uom || "N/A"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "100px",
                          }}
                        >
                          {formatNumber(row?.order_qty) || "0"}{" "}
                        </td>

                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "130px",
                          }}
                        >
                          <NumberInput
                            name="invoice_qty"
                            onChange={(e) =>
                              handleQTYChange(
                                e.target.value,
                                row.item_id,
                                "invoice_qty",
                                row?.order_qty,
                                row,
                                e.target.name
                              )
                            }
                            value={row?.invoice_qty || ""}
                            placeholder="invoice qty"
                            inputClassName="form-control"
                            labelClassName="form-label"
                            labelStyle={{ display: "none" }}
                            customError={
                              formErrors[`row_${row.item_id}_invoice_qty`] || ""
                            }
                          />
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "100px",
                          }}
                        >
                          {formatNumber(row?.unit_rate) || "0"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "80px",
                          }}
                        >
                          {row?.gst_percentage || "0"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "110px",
                          }}
                        >
                          {formatNumber(row?.amount) || "0"}
                        </td>
                        <td
                          colSpan="4"
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "5px",
                          }}
                        >
                          <div className="d-flex gap-3 align-items-center">
                            {" "}
                            <CheckboxInput
                              name="is_active"
                              value={row?.is_active}
                              checked={row?.is_active}
                              handleTextChange={(e) =>
                                handleAccessChange(e, row.item_id)
                              }
                              parentClassName="form-check"
                              checkBoxClassName="form-check-input"
                              labelClassName="form-check-label"
                              labelStyle={{ display: "none" }}
                              checkboxStyle={{ width: "18px", height: "18px" }}
                              disabled={false}
                              required={false}
                            />
                          </div>
                        </td>
                      </tr>

                      {/* Buy Item Details Header (if child rows exist) */}
                      {expandedRows[index] &&
                        row?.buy_item_details?.length > 0 && (
                          <>
                            {/* Sub Item Header */}
                            <tr
                              style={{
                                backgroundColor: "#d1ecf1",
                                fontWeight: "bold",
                              }}
                            >
                              <td></td>
                              <td>Buy Item Code</td>
                              <td>Buy Item Description</td>
                              <td></td>
                              <td>UOM</td>
                              <td>BOM QTY</td>
                              <td colSpan="10"></td>
                            </tr>

                            {row?.buy_item_details &&
                              row?.buy_item_details?.map(
                                (child, childIndex) => (
                                  <tr
                                    key={`${index}-${childIndex}`}
                                    style={{
                                      borderBottom: "1px solid #cccccc",
                                      backgroundColor: "#f8f9fa",
                                    }}
                                  >
                                    <td>
                                      {index + 1}.{childIndex + 1}
                                    </td>

                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={child?.item_code || "N/A"}
                                      >
                                        {child?.item_code || "N/A"}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={child?.item_desc || "N/A"}
                                      >
                                        {child?.item_desc || "N/A"}
                                      </div>
                                    </td>

                                    <td></td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      {child?.uom || "N/A"}
                                    </td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      {formatNumber(child?.qty) || 0}
                                    </td>
                                    <td colSpan="10"></td>
                                  </tr>
                                )
                              )}
                          </>
                        )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              )}

              {/* Total Row */}
              {totalQty >= 1 && (
                <tr
                  style={{
                    borderTop: "2px solid #cccccc",
                    backgroundColor: "#d9d9d9",
                    fontWeight: "bold",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 40000,
                  }}
                >
                  <td></td>
                  <td>Total</td>
                  <td colSpan="3"></td>
                  <td>{formatNumber(totalQty)}</td>
                  <td>{formatNumber(totalInvoiceQty)}</td>
                  <td>{formatNumber(totalUnitRate)}</td>
                  <td></td>
                  <td>{formatNumber(totalAmountData)}</td>
                  <td colSpan="4"></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Row>
      <Row className="mt-3">
        <Col md="4">
          <TextAreaInput
            label="Remark"
            name="remark"
            value={formData?.inputData?.remark}
            onChange={onInputChange}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Remark"
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InvoiceCreate;
